(() => {
  const initialiseBundleScrollers = (root = document) => {
    root.querySelectorAll('[data-bundle-scroller]').forEach((scroller) => {
      if (scroller.dataset.initialised === 'true') return;

      const track = scroller.querySelector('[data-bundle-track]');
      const previous = scroller.querySelector('[data-bundle-previous]');
      const next = scroller.querySelector('[data-bundle-next]');
      if (!track || !previous || !next) return;

      scroller.dataset.initialised = 'true';

      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const overflowing = maxScroll > 2;
        scroller.classList.toggle('is-overflowing', overflowing);
        previous.disabled = !overflowing || track.scrollLeft <= 2;
        next.disabled = !overflowing || track.scrollLeft >= maxScroll - 2;
      };

      const move = (direction) => {
        const item = track.querySelector('.product-v2__bundle-item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * (item.offsetWidth + gap), behavior: 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      requestAnimationFrame(update);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialiseBundleScrollers());
  document.addEventListener('shopify:section:load', (event) => initialiseBundleScrollers(event.target));

  document.addEventListener('change', (event) => {
    const option = event.target.closest('.product-variant--picker');
    if (!option) return;

    const optionLabel = option.querySelector('[data-type-name]')?.dataset.typeName?.trim().toLowerCase();
    if (optionLabel !== 'size') return;

    const product = option.closest('main-product');
    const fillSize = product?.querySelector('[data-product-v2-fill-size] strong');
    if (fillSize && event.target.value) fillSize.textContent = event.target.value;
  });
})();
